(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-open"] && !Shopify.designMode) return;
  try {
    class HeaderSearchOpen extends HTMLElement {
      constructor() {
        super();
        this.searchComponent = null;
        this.contentWrapper = null;
        this.resetButton = null;
        this.searchInput = null;
        this.isContentVisible = false;
        this.initializationAttempts = 0;
        this.maxInitializationAttempts = 20;
      }

      connectedCallback() {
        this.initializeComponent();
      }

      initializeComponent() {
        this.searchComponent = this.querySelector('predictive-search-component');

        if (!this.searchComponent) {
          if (this.initializationAttempts < this.maxInitializationAttempts) {
            this.initializationAttempts++;
            setTimeout(() => this.initializeComponent(), 100);
          }
          return;
        }

        this.contentWrapper = this.searchComponent.querySelector('.predictive-search-form__content-wrapper');
        this.resetButton = this.searchComponent.querySelector('.predictive-search__reset-button');
        this.searchInput = this.searchComponent.querySelector('.search-input');

        if (!this.contentWrapper || !this.searchInput) {
          if (this.initializationAttempts < this.maxInitializationAttempts) {
            this.initializationAttempts++;
            setTimeout(() => this.initializeComponent(), 100);
          }
          return;
        }

        console.log('HeaderSearchOpen: Component initialized successfully');

        this.hideContent();

        // Only show predictive results if input has text
        this.searchInput.addEventListener('focus', () => {
          console.log('HeaderSearchOpen: Focus event triggered');
          if (this.searchInput.value.trim().length > 0) {
            this.showContent();
          }
        });

        // Show/hide content on input
        this.searchInput.addEventListener('input', this.handleInput.bind(this));

        // Hide on blur unless moving focus to content
        this.searchInput.addEventListener('blur', this.handleBlur.bind(this));

        // Reset button clears and hides
        if (this.resetButton) {
          this.resetButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('HeaderSearchOpen: Reset button clicked');

            this.searchInput.value = '';
            this.hideContent();
            this.searchInput.focus();
          });
        }

        // Escape key to hide
        this.searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.hideContent();
            this.searchInput.blur();
          }
        });

        // Click outside to hide
        document.addEventListener('click', this.handleOutsideClick.bind(this));
      }

      showContent() {
        if (this.isContentVisible || !this.contentWrapper) return;

        console.log('HeaderSearchOpen: Showing content');
        this.isContentVisible = true;
        this.contentWrapper.classList.add('show-content');

        if (this.resetButton) {
          this.resetButton.hidden = false;
        }
      }

      hideContent() {
        if (!this.isContentVisible || !this.contentWrapper) return;

        console.log('HeaderSearchOpen: Hiding content');
        this.isContentVisible = false;
        this.contentWrapper.classList.remove('show-content');

        if (this.resetButton) {
          this.resetButton.hidden = true;
        }
      }

      handleInput(e) {
        const value = e.target.value.trim();

        if (value.length > 0) {
          this.showContent();
        } else {
          this.hideContent();
        }
      }

      handleBlur(e) {
        setTimeout(() => {
          const activeElement = document.activeElement;
          const isFocusInContent = this.contentWrapper && this.contentWrapper.contains(activeElement);

          if (!isFocusInContent) {
            this.hideContent();
          }
        }, 150);
      }

      handleOutsideClick(e) {
        if (!this.isContentVisible) return;

        const isClickInside = this.contains(e.target);
        if (!isClickInside) {
          this.hideContent();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick.bind(this));
      }
    }

    if (!customElements.get('header-search-open')) {
      customElements.define('header-search-open', HeaderSearchOpen);
    }
  } catch(e) { console.error(e); }
})();

})();
